import script from "./assessTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./assessTemplate.vue?vue&type=script&setup=true&lang=js"

import "./assessTemplate.vue?vue&type=style&index=0&id=6ead7f7c&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ead7f7c"]])

export default __exports__